document.addEventListener('DOMContentLoaded', function() {
  var stickyHeader = document.getElementById('header-sticky');
  if (!stickyHeader) return;
  var isActive = false;
  var customClass = 'custom-sticky-header-active';

  function handleScroll() {
    var viewportWidth = window.innerWidth || document.documentElement.clientWidth;

    if (viewportWidth >= 768) {
      if (window.scrollY > 100) {
        if (!isActive) {
          stickyHeader.classList.add(customClass);
          isActive = true;
        }
      } else {
        if (isActive) {
          stickyHeader.classList.remove(customClass);
          isActive = false;
        }
      }
    } else {
      // Always remove the sticky class below 768px
      if (isActive) {
        stickyHeader.classList.remove(customClass);
        isActive = false;
      }
    }
  }

  window.addEventListener('scroll', handleScroll);
  window.addEventListener('resize', handleScroll);
  // Run once on load in case page loads scrolled/at mobile
  handleScroll();
});

  // window.addEventListener('DOMContentLoaded', function() {
  //   window.addEventListener('load', function() {
  //     setTimeout(function() {
  //       document.getElementById('site-loader').classList.add('hide');
  //     }, 400); // Optional: fade out delay
  //   });
  // });

document.querySelector('.footer_menu.block_footer.block-1 ul li:last-child a').addEventListener('click', function(event) {
  event.preventDefault(); // Prevent the default link action if necessary
  var reviewButton = document.querySelector('.AirReviews-Widget__FloatButton');
  if (reviewButton) {
    reviewButton.click();
  }
});

// $(document).on('click', '.facets__label', function() {
//   var $this = $(this);
//   $this.toggleClass('active');
//   $this.next('.facets__content').slideToggle(200);
// });



function initAllCountrySelectors() {
  if (typeof Shopify === "undefined" || !Shopify.CountryProvinceSelector) return;

  // Find all country selects on the page
  document.querySelectorAll('select[id="country"]').forEach(function(countrySelect, index) {

    // Find the matching state select (same form or nearest sibling)
    const stateSelect = countrySelect.closest('form, .modal-body').querySelector('select[id="state"]');

    if (stateSelect) {
      // Initialize Shopify Country → Province selector
      new Shopify.CountryProvinceSelector(countrySelect.id, stateSelect.id, {
        hideElement: stateSelect.parentElement.id // e.g., "state-container"
      });
    }

  });
}

// Run on page load
document.addEventListener("DOMContentLoaded", initAllCountrySelectors);

// Run when ANY modal on page is shown
document.addEventListener("shown.bs.modal", function () {
  initAllCountrySelectors();
});
